import Vue from 'vue'
import axios from 'axios'
import { setOffsetFromHeaderDate } from './serverTime'

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')

  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`
  } else {
    // eslint-disable-next-line no-param-reassign
    delete config.headers.Authorization
  }

  return config
})

axios.interceptors.response.use(
  response => {
    setOffsetFromHeaderDate(response.headers && response.headers.date)
    return response
  },
  error => {
    if (error.response) {
      setOffsetFromHeaderDate(error.response.headers && error.response.headers.date)
    }

    const data = error.response && error.response.data
    if (error.response && error.response.status === 403 && data && data.code === 'node_access_denied') {
      Promise.all([import('@/store'), import('@/router')]).then(([{ default: store }, { default: router }]) => {
        store.commit('setNode', null)
        if (router.currentRoute.name !== 'select-node') {
          router.push({ name: 'select-node', query: { motivo: data.message } })
        }
      })
    }

    return Promise.reject(error)
  },
)

Vue.prototype.$http = axios

export default axios
